module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-LightSemiExtIt.d73085c.eot";